<ng-template #illegal>
    <app-page403></app-page403>
</ng-template>

<card *ngIf="!illegalUser; else illegal">
    <div class="row">
        <div class="col-md-6">
            <strong>Analysis Type:</strong> {{getDisplayString(searchResult.analysisType)}}
        </div>
        <div class="col-md-12">
            <strong>Analyte Name:</strong> {{analysisDetails.analyteName}}
        </div>
        <div class="col-md-12">
            <strong>Project Code:</strong> {{analysisDetails.projectCode_AP}}
        </div>
    </div>

    <div *ngIf="searchResult.analysisStatus === 'NewAnalysis'">
        <div class="main-div">
            <h1>Processing</h1>
            <mat-spinner></mat-spinner>
        </div>
        <br>
    </div>

    <div *ngIf="searchResult.analysisStatus === 'Complete' || searchResult.analysisStatus === 'Validation Complete'">
        <div>
            <card [bgColor]="'success'" [color]="'Warn'" [outline]="true">
                <p>
                    <strong>Red Thread Analysis Result: </strong>Analysis results are grouped by sections found in the
                    report. In each section findings are categorised based in severity.
                </p>
                <p>
                    <badge [customColor]="'#EEC2B7'">Red</badge>
                    Validation : Failed
                </p>
                <p>
                    <badge [customColor]="'#F8F8A9'">Yellow</badge>
                    Validation : Review Requested
                </p>
                <p>
                    <badge [customColor]="'#C5EEB2'">Green</badge>
                    Validation : Passed
                </p>
            </card>
        </div>

        <div class = 'row'>
            <div class="icon-container">
                <div class="icon mx-3" *ngIf="role !== 'RV'">
                    <p><strong>Analysis Report</strong></p>
                    <a class="mr-5" target="_blank" href="{{searchResult.analysisResultData}}"
                       (click)="getOutputFilePath()">
                        <file [type]="'xlsx'" [title]="'Data'"></file>
                    </a>
                </div>

                <div class="icon mx-3">
                    <p><strong>Red Thread Audit Report</strong></p>
                    <a class="mr-5" *ngIf="!fetchingEventData" target="_blank" (click)="exportAuditPDF()" style="cursor: pointer; color:#5DADE0;" >
                        <file [type]="'pdf'" [title]="'Red Thread Audit Report'"></file>
                    </a>
                    <div *ngIf="fetchingEventData" style="display: flex; align-items: center; gap: 8px;">
                        <div class="spinner" style="width: 20px; height: 20px; border: 2px solid #5DADE0; border-top-color: transparent; border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
                        <b><p style="color: #5DADE0">Loading...</p></b>
                    </div>
                </div>

                <div class="icon mx-3">
                    <p><strong>Parsed Input Report</strong></p>
                    <a class="mr-5" target="_blank" (click)="exportPDF()" style="cursor: pointer;color:#5DADE0;" >
                        <file [type]="'pdf'" [title]="'Red Thread Parsed Input Report'"></file>
                    </a>
                </div>
            </div>
        </div>

        <div>
            <div>
                <strong>Disclaimer</strong>
            </div>
            <div style='font-size:80%;'>
                Red Thread is not a replacement for any quality control or quality
                assurance process. BioData does not guarantee the accuracy of the
                results of the software. To the fullest extent permitted under
                applicable law. BioData is not liable for any event or loss related
                to the reliance on Red Thread or the output produced by Red Thread.
            </div>
        </div>
        <br>
        <br>
        <div *ngIf="AuditPdfData?.data?.data?.length" id="auditData" #auditData="" style="display: none;">
            <table style=" width: 100%; margin-bottom: 20px;margin-top: 10px; margin-left: 30px; margin-right: 30px;text-align:left; border: 0.2pt;">
                <thead>
                    <tr>
                        <th *ngFor="let col of AuditPdfData?.data.data[0] | keyvalue" style=" color: white;
                font-size: 8pt; background-color: #7787a6;font-weight: bold; padding: 10px 10px 10px 10px;justify-content: center;align-items: left;border: 0.2pt;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                            {{col.key}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let value of AuditPdfData?.data.data">
                        <td *ngFor="let value of value | keyvalue" style="font-size: 8pt; padding: 10px 10px 10px 10px;
                    text-align: left; white-space: nowrap; border: 0.2pt; overflow: hidden; text-overflow: ellipsis;">
                            {{ value.value }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div id="htmlData" #htmlData="" style="display: none;" >
            <div *ngFor="let data of ParsedPdfData">
                <span class="heading">
                    <strong>Run {{data.run}}</strong>
                </span>
                <table style=" width: 100%; margin-bottom: 20px; margin-top: 10px; margin-left: 50px;margin-right: 0px;align-items: center; border: 0.2pt;
                  " class="table-striped">
                    <thead>
                        <tr>
                            <th *ngFor="let column of data?.table[1] | keyvalue " style=" color: white;
                               font-size: 8pt;background-color: #7787a6;font-weight: bold;padding: 4px 10px 4px 5px;justify-content: center;align-items: center;border: 0.2pt; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{column.key}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of data.table | keyvalue">
                            <tr>
                                 <ng-container *ngFor="let item of row.value | keyvalue">
                                     <td style="font-size: 8pt; padding: 4px 10px 4px 5px;text-align: center; white-space: nowrap; border: 0.2pt;  overflow: hidden; text-overflow: ellipsis;">{{ item.value }}</td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>

        <mat-accordion class="example-headers-align">
            <mat-expansion-panel  class="my-3 bg-light" *ngFor="let result of results let i = index" [attr.data-index]="i"
                [expanded]="step === i" (opened)="setStep(i)" hideToggle>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <p><strong>{{result.heading}}</strong></p>
                    </mat-panel-title>
                    <div class="badge">
                        <mat-panel-description>
                            <badge [customColor]="'#C5EEB2'">Green {{result.green}}</badge>
                            <badge [customColor]="'#F8F8A9'">Yellow {{result.yellow}}</badge>
                            <badge [customColor]="'#EEC2B7'">Red {{result.red}}</badge>
                        </mat-panel-description>
                    </div>
                </mat-expansion-panel-header>
                <div class="mb-0" *ngIf="result.heading === 'GRAPHS'">
                    <div style="cursor: pointer;"  (click)="openGraph()">
                        <p class="shadow-lg p-3 mb-5 bg-white rounded text-primary">Click for Visualization</p>
                    </div>
                </div>
                <div *ngFor="let resultItem of result.resultItem">
                    <!-- this code is creating the templates. -->
                    <div *ngIf="result.heading !== 'GRAPHS'">
                        <p><strong><u>{{resultItem.tabletype}}</u></strong></p>
                    </div>
                    <div *ngFor="let item of resultItem.item" class="my-3">
                        <p *ngIf="item.color !== 'Graph'">
                            <strong>
                                <badge [customColor]="item.colorCode">
                                    {{item.color}}
                                </badge>
                            </strong>
                        </p>
                        <div *ngFor="let text of item.message">
                            <div *ngIf="item.color === 'Table' || item.color === 'Graph'; else elseBlock">
                                <div *ngIf="item.color === 'Table';">
                                    <div [innerHTML]="text" class="table table-striped my-5 mx-5"></div>
                                </div>
                            </div>
                            <ng-template #elseBlock>
                                <ul class="nolist">
                                    <li>{{ text }}</li>
                                </ul>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <br>
    <br>
    <div *ngIf="searchResult.analysisStatus === 'Error' || searchResult.analysisStatus === 'Validation Error'">
        <div class="main-div">
            <app-page-500></app-page-500>
        </div>
    </div>
</card>
